import { HTTPStatusCodes } from 'constants/httpStatusCodes';
import API from 'services/API';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';
import { getErrorMessage } from 'UI/utils';

const SUBMIT_MESSAGES = strings.sendoutsV2.alerts.submitMessages;

const buildUpdateSendoutInterviewAlert = ({ severity, body }) => ({
  severity,
  title: strings.formatString(SUBMIT_MESSAGES[severity].title, {
    processType: strings.sendoutsV2.processTypes.interview,
    action:
      severity === 'success' ? SUBMIT_MESSAGES.actions.updated : SUBMIT_MESSAGES.actions.updating
  }),
  autoHideDuration: 5000,
  ...(body ? { body } : {})
});

export const updateSendoutInterview = async ({ sendoutId, interviewId, payload }) => {
  try {
    const response = await API.put(
      `${Endpoints.SendoutInterviews.replace(':id', sendoutId)}/${interviewId}`,
      payload
    );

    if (response.status !== HTTPStatusCodes.Ok) {
      return {
        success: false,
        response,
        alert: buildUpdateSendoutInterviewAlert({
          severity: 'error',
          body: strings.formatString(SUBMIT_MESSAGES.unexpectedStatus, { status: response.status })
        })
      };
    }

    return {
      success: true,
      response,
      alert: buildUpdateSendoutInterviewAlert({ severity: 'success' })
    };
  } catch (error) {
    return {
      success: false,
      error,
      alert: buildUpdateSendoutInterviewAlert({
        severity: 'error',
        body: getErrorMessage(error, error?.message ?? strings.shared.ui.unknownError.title)
      })
    };
  }
};
